export var hitsToSearchItems = function hitsToSearchItems(hits) {
  return hits.map(function (hit) {
    return hitToSearchItem(hit);
  });
};

var hitToSearchItem = function hitToSearchItem(hit) {
  return {
    id: hit.objectID,
    type: hit.contentType,
    label: hit.label,
    previewImage: hit.previewImage,
    subLabel: hit.subLabel
  };
};